function _classCallCheck(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}

var _createClass = function () {
  function n(n, e) {
    for (var t = 0; t < e.length; t++) {
      var o = e[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(n, o.key, o);
    }
  }

  return function (e, t, o) {
    return t && n(e.prototype, t), o && n(e, o), e;
  };
}(),
    _extends = Object.assign || function (n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];

    for (var o in t) {
      Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
  }

  return n;
},
    _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
  return typeof n;
} : function (n) {
  return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
};

!function (n, e) {
  "function" == typeof define && define.amd ? define(["axios"], e) : "object" === ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = e(require("axios")) : n.OTKAnalytics = e();
}(this, function (n) {
  var e = !1,
      t = function t(n, _t, o) {
    if (e) return _t;
    var r = "",
        i = void 0;
    o && (i = new Date(), i.setTime(i.getTime() + 24 * o * 60 * 60 * 1e3), r = ["; expires=", i.toGMTString()].join(""));
    var l = [n, "=", _t, r, "; path=/"].join("");
    return document.cookie = l, _t;
  },
      o = function o(n) {
    if (e) return null;

    for (var t = n + "=", o = document.cookie.split(";"), r = void 0, i = 0; i < o.length; i++) {
      for (r = o[i]; " " === r.charAt(0);) {
        r = r.substring(1, r.length);
      }

      if (0 === r.indexOf(t)) return r.substring(t.length, r.length);
    }

    return null;
  },
      r = function r() {
    for (var n = [], e = "0123456789abcdef", t = 0; t < 36; t++) {
      n.push(e.substr(Math.floor(16 * Math.random()), 1));
    }

    return n[14] = "4", n[19] = e.substr(3 & n[19] | 8, 1), n[8] = n[13] = n[18] = n[23] = "-", n.join("");
  },
      i = function i(n) {
    return o(n) || t(n, r(), 7);
  },
      l = function l(n) {
    if (!n.clientVersion) throw console.log("Error. The clientVersion field cannot be null in the log entry"), new Error("The clientVersion field cannot be null in the log entry");
    if (!n.source) throw console.log("Error. The source field cannot be null in the log entry"), new Error("The source field cannot be null in the log entry");
    if (!n.componentId) throw console.log("Error. The componentId field cannot be null in the log entry"), new Error("The componentId field cannot be null in the log entry");
    if (!n.name) throw console.log("Error. The name field cannot be null in the log entry"), new Error("The guid field cannot be null in the log entry");
    var e = n.logVersion || "2",
        t = n.clientSystemTime || new Date().getTime();
    return _extends({}, n, {
      logVersion: e,
      clientSystemTime: t
    });
  },
      a = function a(t) {
    var o = l(t),
        r = "https://hlg.tokbox.com/prod/logging/ClientEvent";
    if (e) n.post(r, o);else {
      var i = new XMLHttpRequest();
      i.open("POST", r, !0), i.setRequestHeader("Content-type", "application/json"), i.send(JSON.stringify(o));
    }
  },
      s = function () {
    function n(t, o) {
      _classCallCheck(this, n), this.analyticsData = t, e = o && o.server, this.analyticsData.guid = i(t.name);
    }

    return _createClass(n, [{
      key: "addSessionInfo",
      value: function value(n) {
        if (!n.sessionId) throw console.log("Error. The sessionId field cannot be null in the log entry"), new Error("The sessionId field cannot be null in the log entry");
        if (this.analyticsData.sessionId = n.sessionId, !n.connectionId) throw console.log("Error. The connectionId field cannot be null in the log entry"), new Error("The connectionId field cannot be null in the log entry");
        if (this.analyticsData.connectionId = n.connectionId, 0 === n.partnerId) throw console.log("Error. The partnerId field cannot be null in the log entry"), new Error("The partnerId field cannot be null in the log entry");
        this.analyticsData.partnerId = n.partnerId;
      }
    }, {
      key: "logEvent",
      value: function value(n) {
        this.analyticsData = _extends({}, this.analyticsData, n, {
          clientSystemTime: new Date().getTime()
        }), a(this.analyticsData);
      }
    }]), n;
  }();

  return s;
});